import { useEffect, useRef, useState } from 'react';
import { ModalContainer } from '../../../../components/ui/ModalContainer';
import { ChangeDealStageFormContainer } from '../../ChangeDealStage/components';
import { ActiveDealOutOfRange } from './ActiveDealOutOfRange';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';

interface Props {
    empresaId: number;
}

export function NoActiveDealMenu({ empresaId }: Props) {
    const [isOpen, setIsOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const modalRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if(modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        buttonRef.current && 
        !buttonRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    return (
        <div className="relative">
            <button
                ref={buttonRef}
                onClick={() => setIsOpen(!isOpen)}
                className={`
                    px-[10px] py-1 inline-flex justify-center bg-white text-sm font-medium  
                    hover:bg-gray-50 focus:outline-none items-center w-[285px] rounded-l`} 
                >
                <p className="font-semibold text-sm">Sin campaña activa</p>
                <div className={`block transform transition-transform duration-300 ${isOpen ? 'rotate-180' : '-rotate-90 sm:rotate-0'}`}>
                    <ArrowDropDownRoundedIcon />
                </div>
            </button>

            {isOpen && (
            <div
                ref={modalRef}
                className={`absolute shadow-lg bg-white w-full rounded border border-gray-300 z-50 mt-[3px]`}>
                <div className="py-0 overflow-auto ">
                    <div 
                        onClick={() => {
                            setShowModal(true);
                            setIsOpen(false);
                        }}
                        className="flex items-center gap-x-1 px-[10px] py-2 hover:bg-gray-100 cursor-pointer">
                        <PaidRoundedIcon sx={{ height: 15, width: 15 }}/>
                        <p className="font-semibold text-sm cursor-pointer">Crear nueva campaña</p>
                    </div>
                </div>
            </div>
            )}

            {showModal && (
                <ModalContainer>
                    <ChangeDealStageFormContainer setShowModal={setShowModal}>
                        <ActiveDealOutOfRange
                            empresaId={empresaId}
                            onCancelButton={(cancel) => setShowModal(cancel)} />
                    </ChangeDealStageFormContainer>
                </ModalContainer>
            )}
        </div>
    );
}
